// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3HyJP","label":"Radio_label__2ZXac","checkMark":"Radio_checkMark__35mzf","disabled":"Radio_disabled__3QxPh"};